import type { AnyRoute } from "@tanstack/react-router"
import { createFileRoute } from "@tanstack/react-router"
import { zodValidator } from "@tanstack/zod-adapter"

import { SalesMobilePage } from "@/screens/Sales/components/SalesMobilePage"
import { salesOpportunitySearchSchema } from "@/screens/Sales/schemas"

export const Route: AnyRoute = createFileRoute("/app/tablet/sales/")({
  validateSearch: zodValidator(salesOpportunitySearchSchema),
  component: SalesMobilePage,
})
